import React, { useEffect, useState } from "react";
import QurealSection from "../common/QurealSection";
import SectionHeader from "../components/commons/SectionHeader";
import {
    ArrowRightOutlined,
    PlusOutlined,
    SettingOutlined,
} from "@ant-design/icons";
import { Button, Form, Grid, Input, Upload } from "antd";
import { useSendPasswordResetMail } from "../actions/auth";
import { useSelectedOrg, useUpdateOrgMutation } from "../actions/org";
import log from "cslog";
import PhotoButton from "../qforms/standard_elements/PhotoButton";

const { useBreakpoint } = Grid;

export default function OrgnaizationSettings() {
    const [form] = Form.useForm();
    const { isLoading, isSuccess, data: dataOrg } = useSelectedOrg();
    const mutationUpdate = useUpdateOrgMutation();
    const screens = useBreakpoint();
    const isMobile = !screens.sm;

    log.d(dataOrg, "Org Data");

    return (
        <QurealSection
            header={
                <SectionHeader
                    heading="Organization Settings"
                    icon={<SettingOutlined />}
                />
            }
        >
            {isSuccess && (
                <div style={{ padding: isMobile ? "16px" : "15px" }}>
                    <Form
                        form={form}
                        layout="vertical"
                        requiredMark="optional"
                        name="normal_login"
                        style={{
                            maxWidth: isMobile ? "100%" : "300px",
                        }}
                        initialValues={dataOrg}
                        onFinish={(values) => {
                            mutationUpdate.mutate({
                                id: dataOrg.id,
                                data: values,
                            });
                        }}
                    >
                        <Form.Item
                            label="Organization Name"
                            name="name"
                            rules={[
                                {
                                    required: true,
                                    message: "Please enter org name",
                                },
                            ]}
                            // hasFeedback
                        >
                            <Input
                                placeholder="Organization Name"
                                size={isMobile ? "large" : "middle"}
                            />
                        </Form.Item>
                        <Form.Item
                            label="Organization Description"
                            name="description"
                        >
                            <Input.TextArea
                                placeholder="Organization Description"
                                size={isMobile ? "large" : "middle"}
                            />
                        </Form.Item>
                        <Form.Item label="Organization Logo" name="logo">
                            <PhotoButton
                                field={{
                                    collection: "qdb_organization",
                                    field: "logo",
                                }}
                            />
                        </Form.Item>

                        <Form.Item>
                            <Button
                                type="primary"
                                htmlType="submit"
                                size={isMobile ? "large" : "middle"}
                                style={{ width: "100%" }}
                                loading={mutationUpdate.isLoading}
                            >
                                Proceed
                                <ArrowRightOutlined />
                            </Button>
                        </Form.Item>
                    </Form>
                </div>
            )}
        </QurealSection>
    );
}
